<template>
  <MyOrdersHighFrequencyCard v-bind="data">
    <template #header>
      <MyOrdersWinningBadge v-if="data.hasWinnings" />
      <MyOrdersStatusBadgeHighFrequency
        v-else-if="data.status === HighFrequency_OrderStatus.Cancelled"
        :status="data.status"
      />
    </template>
  </MyOrdersHighFrequencyCard>
</template>

<script lang="ts" setup>
import {
  type HighFrequency_Order,
  HighFrequency_OrderStatus,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type MyOrdersHighFrequencyCardPastProps = {
  data: HighFrequency_Order
}

defineProps<MyOrdersHighFrequencyCardPastProps>()
</script>
